import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import SuccessfulMonitor from 'shared/ui/icons/SuccessfulMonitor';
import ProblemMonitor from 'shared/ui/icons/ProblemMonitor';
import PauseMonitor from 'shared/ui/icons/PauseMonitor';
import UnknownMonitor from 'shared/ui/icons/UnknownMonitor';
import Problem from 'shared/ui/icons/General/Problem';
import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';

import {PALETTE} from 'shared/config/model/palette';

import {GeoStatusState, GeoStatusTone, GEO_STATE_TONE} from '../geoStatusState';

import styles from './GeoStatusBanner.module.scss';

interface IGeoStatusBannerProps {
    item: IHttpMonitorItem;
    state: GeoStatusState;
}

const TEXT_BG_BY_TONE: Record<GeoStatusTone, string> = {
    success: styles.okBackground,
    warning: styles.warningBackground,
    problem: styles.problemBackground,
    neutral: styles.neutralBackground,
};

const getIcon = (state: GeoStatusState): React.ReactNode => {
    switch (state) {
        case 'all_ok':
            return <SuccessfulMonitor />;
        case 'warning':
            return <Problem color={PALETTE.warning} />;
        case 'incident':
            return <ProblemMonitor />;
        case 'paused':
            return <PauseMonitor />;
        case 'waiting':
        default:
            return <UnknownMonitor />;
    }
};

const getText = (state: GeoStatusState, fail: number, total: number): string => {
    switch (state) {
        case 'all_ok':
            return t`Сайт доступен из всех локаций`;
        case 'warning':
        case 'incident':
            return t`Сайт недоступен в ${fail} из ${total} локаций`;
        case 'paused':
            return t`Проверки приостановлены`;
        case 'waiting':
        default:
            return t`Ждём первой проверки`;
    }
};

const GeoStatusBanner: React.FC<IGeoStatusBannerProps> = ({item, state}) => {
    return (
        <div className={styles.container}>
            <span className={styles.icon}>{getIcon(state)}</span>
            <span className={cn(styles.text, TEXT_BG_BY_TONE[GEO_STATE_TONE[state]])}>
                {getText(state, item.fail_locations_count ?? 0, item.total_locations_count)}
            </span>
        </div>
    );
};

export default GeoStatusBanner;
